import type { JSX } from 'react'
import { shortenNames } from '@/lib/shortenNames'

// Ordinary spaces at the edges of flex items collapse away, these do not
const NBSP = '\u00a0'

/**
 * A byline's names on a card. Up to three are all shown, a longer list shows
 * the first two and a muted count of the rest. The names are cut off with an
 * ellipsis where the card ends, the count always stays.
 *
 * A lead is what the article is published under instead, the organisation. It
 * comes first and the names follow it muted, in parentheses, the way the byline
 * reads in the editor.
 */
export const BylineNames = ({ names, lead }: {
  names: string[]
  lead?: string
}): JSX.Element => {
  const { shown, hiddenCount } = shortenNames(names)
  const count = hiddenCount > 0 && `${NBSP}+${hiddenCount}`

  if (!lead) {
    return (
      <span className='flex min-w-0'>
        <span className='truncate'>{shown.join(', ')}</span>
        {count && <span className='shrink-0 opacity-60'>{count}</span>}
      </span>
    )
  }

  return (
    <span className='flex min-w-0'>
      <span className='shrink-0'>{lead}</span>
      {!!names.length && (
        <span className='flex min-w-0 opacity-60'>
          <span className='truncate'>{`${NBSP}(${shown.join(', ')}`}</span>
          {count && <span className='shrink-0'>{count}</span>}
          <span className='shrink-0'>)</span>
        </span>
      )}
    </span>
  )
}
